import React from "react";
import { Link } from "@tanstack/react-router";
import { cn } from "~/lib/utils";
import ImageDcmLogoHorizontalWhiteUrl from "~/img/logo/dcm-logo-horizontal-white.png";
import IcfBpLogo from "~/img/icfbp-logo-mono.svg?react";

export const Footer = (props: React.HTMLAttributes<HTMLElement>) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      {...props}
      className={cn("z-10 bg-gray-950 py-8 text-gray-200", props.className)}
    >
      <div className="container mx-auto max-w-screen-xl px-4">
        <div className="flex flex-col items-center justify-between space-y-4 sm:flex-row sm:space-y-0">
          <div className="flex grow-0 flex-col items-start gap-4">
            <img
              src={ImageDcmLogoHorizontalWhiteUrl}
              alt="DreamCoachMatch Logo"
              style={{ height: 32, width: "auto" }}
            />
            <p className="grow text-sm italic text-gray-500">
              The World's Coaching Marketplace
            </p>
            <IcfBpLogo
              style={{ height: "48px" }}
              className="text-gray-100 mt-4"
            />
            <div className="text-muted-foreground mt-4 text-center text-sm">
              © {currentYear} DreamCoachMatch. All rights reserved.
            </div>
          </div>
          <nav className="md:w-xs flex w-full max-w-full flex-col gap-2 text-sm">
            <Link to="/" className="text-muted-foreground hover:text-white">
              Home
            </Link>
            <Link
              to="/coach"
              className="text-muted-foreground hover:text-white"
            >
              Join as a coach
            </Link>
            <Link
              to="/discovery"
              className="text-muted-foreground hover:text-white"
            >
              Join as a member
            </Link>
            {/* TODO: Create privacy and terms pages */}
            {/* <Link to="/privacy" className="text-muted-foreground hover:text-white">
              Privacy
            </Link>
            <Link to="/sms-terms" className="text-muted-foreground hover:text-white">
              Terms
            </Link> */}
            <a
              href="mailto:info@dreamcoachmatch.com"
              className="text-muted-foreground hover:text-white"
            >
              Contact
            </a>
          </nav>
        </div>
      </div>
    </footer>
  );
};
